import { ResourceType } from "../../../../../services/cloudchipr.api";

export const resourceTypeFilterSubmitHandlerKeyGenerator = (
  resourceType?: ResourceType,
) => `${resourceType ?? ""}_filters_form_submit_handler`;
